// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Group, Menu, Modal, Text } from '@mantine/core';
import { i18n } from '@lingui/core';
import { IconChevronDown } from '@tabler/icons';
import { FC, useContext, useState } from 'react';
import moment from 'moment';
import { useDisclosure } from '@mantine/hooks';
import Dot from '../../../Atoms/Dot';
import { RecommendationS } from '../../../Service/RecommendationS';
import { BookingState, RecommendationDto } from '../../../Types/RecommendationT';
import { Contact } from '../../../Service/ContactS';
import { RecommendationContext } from './RecommendationsPane';
import RecommendationBookingStateModal from './Modals/RecommendationChangeBookingStateModal';

interface Props {
  recommendation: RecommendationDto;
  recommendedContact: Contact;
  contactEmail: string | undefined | null;
}

const RecommendationStateStatus: FC<Props> = ({ recommendation, contactEmail, recommendedContact }) => {
  const { bookingState, lastModifiedBookingState } = recommendation;
  const { patchRecommendation } = useContext(RecommendationContext);
  const [opened, { open, close }] = useDisclosure(false);
  const [state, setBookingState] = useState<BookingState>(bookingState);

  return (
    <Box
      p={5}
      pr="xs"
      pl="md"
      sx={(theme) => ({ borderRadius: theme.spacing.xs, backgroundColor: 'white', fontSize: theme.fontSizes.xs })}
    >
      <Group position="apart">
        <Group>
          <Dot colour={RecommendationS.getColourByBookingState(bookingState)} />
          <Text weight="bolder">{i18n._(`bookingState.${bookingState}`)}</Text>
        </Group>

        <Menu radius="md" shadow="md" width={130} position="bottom-end" transition="scale-y">
          <Menu.Target>
            <div>
              <IconChevronDown size={16} style={{ cursor: 'pointer' }} />
            </div>
          </Menu.Target>
          <Menu.Dropdown>
            {['OPEN', 'OFFERED', 'BOOKED', 'CANCELED'].map((_bookingState) => (
              <Menu.Item
                key={_bookingState}
                icon={<Dot colour={RecommendationS.getColourByBookingState(_bookingState as BookingState)} />}
                onClick={() => {
                  setBookingState(_bookingState as BookingState);
                  open();
                }}
              >
                {i18n._(`bookingState.${_bookingState}`)}
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </Group>
      {lastModifiedBookingState && (
        <Text italic color="dimmed">{`seit ${moment(lastModifiedBookingState).format('DD.MM.YY HH:mm')}`}</Text>
      )}
      <Modal
        closeOnClickOutside={false}
        size={550}
        transition="slide-down"
        opened={opened}
        onClose={close}
        title={
          <Text size="lg" weight="bolder">
            E-Mail senden
          </Text>
        }
      >
        <RecommendationBookingStateModal
          recommendation={recommendation}
          newBookingState={state}
          patchRecommendation={patchRecommendation}
          contactEmail={contactEmail}
          recommendedContact={recommendedContact}
          closeModal={() => close()}
        />
      </Modal>
    </Box>
  );
};

export default RecommendationStateStatus;
